<div class="toast-container">
  <p-toast position="top-right" key="tr">
    <ng-template let-message pTemplate="message">
      <div class="flex" style="flex: 1">
        <div
          class="p-text-center flex justify-content-center align-items-center"
        >
          <img
            src="assets/icons/tick-circle.svg"
            *ngIf="message.severity === 'success'"
          />
          <img
            src="assets/icons/warn-circle.svg"
            *ngIf="message.severity === 'warn'"
          />
          <img
            src="assets/icons/info-circle.svg"
            *ngIf="message.severity === 'info'"
          />
          <img
            src="assets/icons/close-circle.svg"
            *ngIf="message.severity === 'error'"
          />
          <div class="flex flex-column">
            <div class="summary">{{ message.summary }}</div>
            <div class="detail">{{ message.detail }}</div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-toast>
</div>
